import script from "./stdOnboardingThirdPage.vue?vue&type=script&setup=true&lang=js"
export * from "./stdOnboardingThirdPage.vue?vue&type=script&setup=true&lang=js"

import "./stdOnboardingThirdPage.vue?vue&type=style&index=0&id=08841cdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08841cdf"]])

export default __exports__